import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';

// Potentially just receive an object and map over it
const TableActions = ({
  children,
  handlePauseCampaigns,
  handleRunCampaigns,
  handleArchiveCampaigns,
  disabled,
}) => (
  <ul className="subnav">
    <li>
      <Button type="default" onClick={handlePauseCampaigns} disabled={disabled}>
        Pause
      </Button>
    </li>
    <li>
      <Button type="default" onClick={handleRunCampaigns} disabled={disabled}>
        Run
      </Button>
    </li>
    <li>
      <Button type="default" onClick={handleArchiveCampaigns} disabled={disabled}>
        Archive
      </Button>
    </li>
    {children}
  </ul>
);

TableActions.defaultProps = {
  children: null,
};

TableActions.propTypes = {
  children: PropTypes.node,
  handlePauseCampaigns: PropTypes.func.isRequired,
  handleRunCampaigns: PropTypes.func.isRequired,
  handleArchiveCampaigns: PropTypes.func.isRequired,
};

export default TableActions;
